import LiveApiClient from "../api/LiveApiClient";
import { DB } from "./Cache.util";
import { CanceledError } from "axios";

export class ProductUtil {
	/**
	 * @param {Item} options.product
	 * @param options.profile_token
	 * @param options.organization
	 * @returns {URL|undefined}
	 */
	static Make_Pdf_Qr_Code_Url(options) {
		if (!options.product?.pdf) {
			return;
		}

		const qr_url = new URL("/qr", "https://bosslogics.live"); // TODO ... env variable for prod live site
		options.product?.id && qr_url.searchParams.set("product", options.product.id);

		const url = this.Make_Pdf_Url(options);
		qr_url.searchParams.set("url", url.toString());

		return qr_url;
	}

	/**
	 * @param {Item} options.product
	 * @param options.profile_token
	 * @param options.organization
	 * @returns {URL|undefined}
	 */
	static Make_Pdf_Url(options) {
		if (!options.product?.pdf) {
			return;
		}

		const url = new URL(options.product.pdf);
		options.profile_token && url.searchParams.set("profile", options.profile_token);
		options.organization && url.searchParams.set("org", options.organization.toString());
		options.catalog && url.searchParams.set("catalog", options.catalog);

		return url;
	}
	/**
	 * @param {Item} options.product
	 * @param options.profile_token
	 * @param options.organization
	 * @returns {URL|undefined}
	 */
	static Make_Html_Url(options) {
		if (!options.product?.html) {
			return;
		}

		const url = new URL(options.product.html);
		options.profile_token && url.searchParams.set("profile", options.profile_token);
		options.organization && url.searchParams.set("org", options.organization);
		options.catalog && url.searchParams.set("catalog", options.catalog);

		return url;
	}

	static GetDifferences(a, b) {
		const variableAttributes = this.CurrentAttributes?.filter(attribute => attribute.values?.length > 1);
		if (!variableAttributes) {
			return [];
		}
		return variableAttributes.filter(({ reference }) => a?.[reference] !== b?.[reference]);
	};

	static async GetProduct(id, { variations, signal, apiContext }) {
		const filters = [{ property: "id", value: id }];

		const options = {
			headers: {
				'api-key': apiContext.apiKey,
				'cache-control': !localStorage.getItem('nocache') ? 'private' : 'no-cache',
				account: apiContext.account,
			},
			params: {
				variations,
				filters: JSON.stringify([filters]),
			},
			signal,
		};
		const item = await LiveApiClient.get(`/Item`, options).then(r => r.data?.at(0));
		if (item) {
			return item;
		}
	}
	static async FindProduct(properties, value, { variations, signal, apiContext }) {
		const filters = [
			!isNaN(value) ? { property: "id", value } : undefined,
			{ property: "common_sku", value },
			{ property: "upc", value },
			{ property: "manufacturers_product_number", value },
			{ property: "rfid", value },
			{ property: "{inventory.stock_number}", value },
			{ property: "{inventory.serial_number}", value },
		].filter(v => v);
		const options = {
			headers: {
				'api-key': apiContext.apiKey,
				'cache-control': !localStorage.getItem('nocache') ? 'private' : 'no-cache',
				account: apiContext.account,
			},
			params: {
				variations,
				filters: JSON.stringify([filters]),
			},
			signal,
		};
		const item = await LiveApiClient.get(`/Item`, options).then(r => r.data?.at(0));
		if (item) {
			return item;
		}
	}
	static async GetPreloadedProduct(catalogId, key) {
		const cacheKey = ["items", ...key.map(it => it.toString())];
		return DB.Get(DB.Make_Name(catalogId), cacheKey);
	};

	static async SetPreloadedProduct(catalogId, attributeKeys, item) {
		const dbName = DB.Make_Name(catalogId);
		const settled = await Promise.allSettled(attributeKeys?.filter(it => item[it]).map(key => {
			const itemValue = item[key];
			const sets = [DB.Set(dbName, ["items", key, itemValue], item)];
			// TODO ... this can probably be done better (and save space) with an INDEX
			if (typeof itemValue === "string") {
				if (itemValue.toLowerCase() !== itemValue) {
					sets.push(DB.Set(dbName, ["items", key, itemValue.toLowerCase()], item));
				}
				if (itemValue.toUpperCase() !== itemValue) {
					sets.push(DB.Set(dbName, ["items", key, itemValue.toUpperCase()], item));
				}
			}
			return Promise.all(sets);
		}));

		return settled.filter(it => it.status === "fulfilled").map(it => it.value);
	}

	static async PreloadProductGroup({ catalog, groupField, groupCode, attributes, loadOptions } = {}) {
		this.CurrentAttributes = attributes;

		loadOptions.signal = loadOptions.abortController.signal;
		const dbName = DB.Make_Name(catalog.id);

		const limit = loadOptions.limit || 100;
		let offset = 0;
		const filter = { '{status}': 1, '{active}': 1 };
		filter[`{${groupField}}`] = encodeURIComponent(groupCode);

		// TODO: Use x-total-count header to determine if we need to load more pages
		loadOptions.params = { filter: JSON.stringify(filter), limit, offset };
		let itemsChunk = null;

		do {
			let cacheKey = ["PreloadProductGroup", "Group", groupCode, "Offset", offset];
			itemsChunk = await DB.Get(dbName, cacheKey);
			if (!itemsChunk) {
				try {
					const params = { ...loadOptions.params, offset };
					itemsChunk = await LiveApiClient.get(`/Item/`, { ...loadOptions, params }).then(response => response.data);
				} catch (error) {
					if (!(error instanceof CanceledError)) {
						console.error(error);
					}
					return;
				}

				if (dbName) {
					DB.Set(dbName, cacheKey, itemsChunk);
				}
			}

			offset += limit;
		} while (itemsChunk.length);

		/*
				NOTE !!!!!!!!!!
				i think this is all here to try and pre-set variations for preloads
				but it doesn't seem needed cuz stuff works now
				
				a better strategy might be to
				- determine distance 1 products
				- make the same Item/+variations call that will happen when variation button clicked
					- create that FetchProduct() and use it where manual "Item/" GETs are used and use it here too
				- which will DB cache it
				- now when clicked, no network call is needed
		 */

		// const variableAttributes = attributes?.filter(attribute => attribute.values?.length > 1) ?? [];
		//
		// const getDistance = (a, b) =>
		// 	variableAttributes
		// 		.reduce((acc, { reference }) => acc + (a[reference] !== b[reference] ? 1 : 0), 0);
		//
		// // Optimized for speed: performs 30% faster than using sort() inside loop
		// const items_by_attribute_value = {};
		// variableAttributes.forEach(({ reference, values }) => {
		// 	items_by_attribute_value[reference] = { '': [] };
		// 	values.forEach(value => items_by_attribute_value[reference][value?.text] = [])
		// });
		// items.forEach(item => variableAttributes.forEach(({ reference }) => {
		// 	// Every attribute variation must have an array
		// 	items_by_attribute_value[reference][item[reference] || ''] ??= [];
		// 	items_by_attribute_value[reference][item[reference] || ''].push(item);
		// }));
		//
		// const findLowestDistance = (reference, value, distances) => {
		// 	let lowest = false;
		// 	let lowestDistance = false;
		// 	const items = items_by_attribute_value[reference][value.text || ''];
		// 	const len = items.length;
		//
		// 	// Use for loop for better performance
		// 	for (let i = 0;i < len;i++) {
		// 		if (items[i][reference] === value.text) {
		// 			const currentDistance = distances[items[i].id];
		// 			if (!lowest || currentDistance < lowestDistance) {
		// 				lowest = items[i];
		// 				lowestDistance = currentDistance;
		// 				if (lowestDistance < 1) {
		// 					break; // Found a match
		// 				}
		// 			}
		// 		}
		// 	}
		// 	return lowest;
		// }
		//
		// // Calculate variations
		// items.forEach(item => {
		// 	const distances = {};
		// 	item.variations = {};
		// 	items.forEach(otherItem => distances[otherItem.id] = getDistance(item, otherItem));
		//
		// 	variableAttributes.forEach(({ reference, values }) => {
		// 		item.variations[reference] = [];
		//
		// 		values.forEach(value => {
		// 			const variation = findLowestDistance(reference, value, distances);
		// 			if (variation) {
		// 				const record = [
		// 					{ ...value, image: variation.image_0 },
		// 					variation.id,
		// 					distances[variation.id],
		// 					variation,
		// 				];
		// 				item.variations[reference].push(record);
		// 			}
		// 		});
		// 	});
		// });
	}
}